import useRequest, { IDataRequest } from '@hooks/useRequest';
import { IConta } from '@model/Conta';
import { IContaLinha } from '@model/ContaLinha';
import { EnumEmpresa } from '@model/Empresa';
import { EnumOperadora } from '@model/Operadora';
import { BooleanString } from '@utils/TypeHelpers';
import React from 'react';

export interface IContaFilter {
    numeroContrato: string
    empresaId: EnumEmpresa
    competencia: string
}

export interface IContaLinhaFilter {
    linhaOrfa: BooleanString
}

export interface IImportarRequest {
    empresaId: EnumEmpresa
    //operadoraId: EnumOperadora
    numeroContrato: string
}

const controller = "/Conta";

export function useContaService () {
    const _request = useRequest();

    const listar = React.useCallback((request: IDataRequest<IContaFilter>) => {
        return _request.getData<IConta[]>(`${controller}/Listar`, request);
    }, [_request]);

    const listarItens = React.useCallback((linhaId: number, request: IDataRequest<IContaLinhaFilter>) => {
        return _request.getData<IContaLinha[]>(`${controller}/listarLinhas/${linhaId}`, request);
    }, [_request]);

    const importar = React.useCallback((arquivo: File, request?: IImportarRequest) => {
        const formData = new FormData();
        formData.append('arquivo', arquivo);
        formData.append('empresaId', request!.empresaId.toString());
        formData.append('numeroContrato', request!.numeroContrato);

        return _request.upload<IConta>(`${controller}/Importar`, formData);
    }, [_request]);

    return React.useMemo(() => ({
        listar, listarItens, importar
    }), [listar, listarItens, importar]);
}